import styles from './footer.module.scss';
import { useNavigate } from 'react-router-dom'
import personPng from '../assets/images/person.png';
import mophonePng from '../assets/images/mophone.png';
import phonePng from '../assets/images/phone.png';
import emailPng from '../assets/images/email.png';
import addressPng from '../assets/images/address.png';
import taobaoPng from '../assets/images/taobao.png';
import { getLangName as t } from '../utils/index'

function Footer() {
    const navigate = useNavigate();
    const handleNavi = (path) => {
        navigate(path);
    }
    return (
        <>
            <div className={styles.footer_info}>
                <div className={styles.info_tab} style={
                    {
                        width: '20%'
                    }
                }>
                    <div className={styles.tab_item} onClick={() => handleNavi('/')}>{t('home')}</div>
                    <div className={styles.tab_item}>{t('product')}</div>
                    <div className={styles.tab_item} onClick={() => handleNavi('/settings')}>{t('case')}</div>
                    <div className={styles.tab_item} onClick={() => handleNavi('/contactUs')}>{t('contact')}</div>
                </div>
                <div className={styles.info_tab} style={
                    {
                        width: '47%'
                    }
                }>
                    <div className={styles.tab_item}>{t('FollowUs')}</div>
                    <img src={taobaoPng} style={{ width: '170px' }} />
                    {/* <div className={styles.tab_item}>{t('FollowWeChatofficialaccount')}</div>
                    <div className={styles.tab_item}>{t('FollowthecompanysWeiboaccount')}</div>
                    <div className={styles.tab_item}>{t('contact')}</div> */}
                </div>
                <div className={styles.info_tab} style={
                    {
                        width: '33%'
                    }
                }>
                    <div className={styles.tab_item} >{t('contact')}</div>
                    <div className={styles.tab_item}>
                        <img src={personPng} />{t('ContactPerson')}：杜经理</div>
                    <div className={styles.tab_item}>
                        <img src={phonePng} />
                        {t('Phone')}：15325888759</div>
                    <div className={styles.tab_item}>
                        <img src={emailPng} />
                        {t('Email')}：15325888759@163.com</div>
                    <div className={styles.tab_item}>
                        <img src={addressPng} />
                        {t('Address')}：广东省深圳市龙华区福城街道溢佳科技园2号厂房4楼</div>
                </div>
            </div>
            <div className={styles.footer}>
                <p> <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2024193280号</a></p>
            </div>
        </>
    )
}

export default Footer;